import { supabase } from "@/lib/supabase";

export async function getOrCreateDirectConversation(myId: string, otherUserId: string) {
  if (!myId || !otherUserId) {
    throw new Error("Both user IDs are required.");
  }

  if (myId === otherUserId) {
    throw new Error("You cannot start a conversation with yourself.");
  }

  // 1) Try to find an existing convo shared by both users
  const { data: shared, error: sharedError } = await supabase
    .from("conversation_members")
    .select("conversation_id")
    .eq("user_id", myId);

  if (sharedError) throw sharedError;

  const convoIds = (shared ?? []).map((r: any) => r.conversation_id);
  if (convoIds.length > 0) {
    const { data: otherMember, error: otherError } = await supabase
      .from("conversation_members")
      .select("conversation_id")
      .in("conversation_id", convoIds)
      .eq("user_id", otherUserId)
      .limit(1)
      .maybeSingle();

    if (otherError) throw otherError;
    if (otherMember?.conversation_id) return otherMember.conversation_id as string;
  }

  // 2) Create a new conversation with both members in a single transaction
  // Use a database function to ensure atomicity and avoid RLS issues
  const { data, error } = await supabase.rpc('create_direct_conversation', {
    user_id_1: myId,
    user_id_2: otherUserId
  });

  if (error) throw error;
  if (!data) throw new Error("Failed to create conversation");

  return data as string;
}
